import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    info: JSON.parse(localStorage.getItem("userInfo")) || null,
    token: localStorage.getItem("token") || "",
  },
  getters: {},
  mutations: {
    SET_USER_INFO(state, info) {
      state.info = info;
      localStorage.setItem("userInfo", JSON.stringify(info));
    },
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
  },
  actions: {},
  modules: {},
});
